import { Set } from 'immutable';

export type Dialog = React.ReactElement;

export type DialogSet = Set<Dialog>;

export type State = {
  dialogs: DialogSet;
};

export const initialState: State = {
  dialogs: Set(),
};

/* This is deprecated, please use the following:
 *
 * openModal = () => this.setState({ modal true })}
 * closeModal = () => this.setState({ modal false })}
 * 
 * render() {
 *   return (
 *     <div>
 *       <button onClick={this.openModal}>
 *         click to open modal
 *       </button>
 *       <Modal isOpen={this.state.modal}>
 *         <Dialog onRequestHide={this.closeModal}>
 *           some dialog content
 *         </Dialog>
 *       </Modal>
 *     </div>
 *   );
 * }
 * 
 */
export default function reducer(state: State = initialState, action: BannersActions): State {
  switch (action.type) {
    case 'modals/ADD':
      return { ...state, dialogs: state.dialogs.add(action.dialog) };
    case 'modals/REMOVE':
      return { ...state, dialogs: state.dialogs.remove(action.dialog) };
    default:
      return state;
  }
}

type addAction = {
  type: 'modals/ADD';
  dialog: Dialog;
};

export function addModal(dialog: Dialog): addAction {
  return {
    type: 'modals/ADD',
    dialog,
  };
}

export type removeAction = {
  type: 'modals/REMOVE';
  dialog: Dialog;
};

export function removeModal(dialog: Dialog): removeAction {
  return {
    type: 'modals/REMOVE',
    dialog,
  };
}

export type BannersActions = addAction | removeAction;
